import { StateManager } from '../core/StateManager';

type BitElementMap = Record<string, HTMLElement>;

export class StatusBits {
  private unsubscribers: (() => void)[] = [];

  constructor(
    state: StateManager,
    elements: BitElementMap,
  ) {
    this.unsubscribers.push(
      state.subscribe('alarms', (alarms) => {
        for (const [key, value] of Object.entries(alarms)) {
          const elId = `bit${key.charAt(0).toUpperCase()}${key.slice(1)}`;
          const el = elements[elId];
          if (el) {
            el.classList.toggle('active', value);
          }
        }
      }),
    );

    this.unsubscribers.push(
      state.subscribe('warnings', (warnings) => {
        for (const [key, value] of Object.entries(warnings)) {
          const elId = `bit${key.charAt(0).toUpperCase()}${key.slice(1)}`;
          const el = elements[elId];
          if (el) {
            el.classList.toggle('warning-active', value);
          }
        }
      }),
    );
  }

  destroy(): void {
    this.unsubscribers.forEach((fn) => fn());
    this.unsubscribers = [];
  }
}
